/**
 * 是否要展示学习圈相关的内容
 * @see https://app.asana.com/0/60697097430687/1202458236205109
 * @param params
 */
export function isShowLearningCliclePart() {
    return false;
}
